import { NavProps } from 'uikit'

const links: NavProps['links'] = [
  {
    label: 'Exchange',
    href: '/swap'
  },
  {
    label: 'Liquidity',
    href: '/pool'
  }
]

export default links
